export default {
  header: {
    title: "💛 Donner un pourboire à l'équipe",
    subtitle: "100 % va à l'équipe",
  },
  buttons: {
    other: 'Autre',
    none: 'Aucun',
  },
  summary_label: 'Pourboire',
  form: {
    custom_tip: {
      validation: {
        max: '{{value}} est le pourboire maximum',
      },
    },
  },
};
